import Collection from 'core/model/Collection';
import CloudExportAzureSpn from './CloudExportAzureSpn';

export default class CloudExportAzureSpnCollection extends Collection {
  get url() {
    return '/api/ui/cloudExportAzureSpn';
  }

  get model() {
    return CloudExportAzureSpn;
  }
}
